import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  Button,
  Select,
  Box
} from '@chakra-ui/react';
import { MainteTrainsType } from '../Table/MaintenanceTrainsTable';
import { UpdateTrainsApi } from '../../../../apis/UpdateMaintenance.api';
import { TrainGroupsNameType } from '../../../../apis/ApiClient';
import { CustomNumberInput } from '../../../atoms/CustomNumberInput';
import { AxiosError } from 'axios';

interface ResponseType {
  success: boolean;
  data: MainteTrainsType[] | TrainGroupsNameType[] | null;
  message: unknown | null;
}

interface props {
  isOpen: boolean;
  onClose: () => void;
  EditData: MainteTrainsType | undefined;
  TrainGroupsDatas: TrainGroupsNameType[] | undefined;
  setMaintenanceDatas: React.Dispatch<
    React.SetStateAction<MainteTrainsType[] | undefined>
  >;
  CreateOrUpdateStateSwitch: () => void;
}

const InitTrainType = (
  editData: MainteTrainsType | undefined,
  trainGroupData: TrainGroupsNameType[] | undefined
) => {
  if (trainGroupData === undefined) return;
  for (let i = 0; i < trainGroupData?.length; i++) {
    if (trainGroupData[i].type === editData?.train_group_name) {
      return trainGroupData[i].id;
    }
  }
  return 1;
};

const GetTrainNoInputCheckData = (addData: string | undefined) => {
  if (addData === undefined) {
    return { ViewInt: 4, ViewDigit: 0, ValueMin: 0, Value: '' };
  }
  return { ViewInt: 4, ViewDigit: 0, ValueMin: 0, Value: addData };
};

const TrainsEditWindow: React.FC<props> = (props) => {
  const {
    isOpen,
    onClose,
    EditData,
    TrainGroupsDatas,
    setMaintenanceDatas,
    CreateOrUpdateStateSwitch
  } = props;
  const [trainNo, setTrainNo] = useState(EditData?.no.toString());
  const [trainGroup, setTrainGroup] = useState(
    InitTrainType(EditData, TrainGroupsDatas)
  );

  const PostApi = async () => {
    if (EditData !== undefined && EditData.id !== undefined) {
      const response: ResponseType = await UpdateTrainsApi(EditData.id, {
        no: trainNo,
        train_group_id: trainGroup
      });

      if (
        response.message !== null &&
        (response.message as AxiosError).status?.toString() === '409'
      ) {
        alert('既に登録されている車号です。');
        return;
      } else if (response.success === false) {
        alert('編集に失敗しました。');
        return;
      }
      setMaintenanceDatas(response.data as MainteTrainsType[]);
      CreateOrUpdateStateSwitch();
      onClose();
    }
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent h='260px' maxW='1100px'>
          <ModalHeader
            textAlign='center'
            bg='gray.800'
            color='white'
            fontSize='16'
          >
            車両を編集
          </ModalHeader>
          <ModalCloseButton color='white' />
          <ModalBody>
            <Box
              position='relative'
              display='grid'
              gridTemplateColumns='1fr 6fr'
            >
              <Text mt={4}>車号</Text>
              <CustomNumberInput
                CheckInfo={GetTrainNoInputCheckData(EditData?.no?.toString())}
                inputValue={trainNo}
                setValue={setTrainNo}
              />

              <Text mt={5}>形式</Text>
              <Select
                mt={2}
                w='20%'
                value={trainGroup}
                onChange={(e) => setTrainGroup(Number(e.target.value))}
              >
                {TrainGroupsDatas?.map((data, i) => {
                  return (
                    <option key={'option' + i} value={data.id}>
                      {data.type}
                    </option>
                  );
                })}
              </Select>
            </Box>
            <Button mt={10} onClick={() => PostApi()}>
              更新
            </Button>
            <Button mt={10} ml={10} onClick={() => onClose()}>
              取り消す
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
export default React.memo(TrainsEditWindow);
